import React, {useState} from 'react'
import 'animate.css/animate.compat.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
// general imports
import ScrollTop from './general/ScrollTop';
import PageNotFound from './general/PageNotFound';
import Sidebar from './general/Sidebar';
// page imports
import Home from './components/Home';
import Login from './components/Login';
import PrivacyPolicy from './components/PrivacyPolicy';
import Checkout from './components/Checkout';
import ProductDetails from './components/ProductDetails';
// admin imports
import AdminDashboard from './Admin/AdminDashboard';
import AddProduct from './Admin/AddProduct';
import Profile from './Admin/Profile';
import AddStaff from './Admin/AddStaff';
import ManageOrders from './Admin/ManageOrders';
import Users from './Admin/Users';
import AddDeliveryAgent from './Admin/AddDeliveryAgent';
import DeliveryHistory from './Admin/OrdersDelivered';

// staff imports
import StaffDashboard from './SubAdmin/StaffDashboard';
import Store from './SubAdmin/Store';
import BottomBar from './general/BottomBar';
import MobileSidebar from './general/MobileSidebar';
import Copyright from './general/Copyright';
import ProDetails from './Admin/ProDetails';
import Shop from './components/Shop';
import OrderHistory from './components/OrderHistory';
// delivery imports
import DeliveryLogin from './components/DeliveryLogin';
import DeliveryDashboard from './Delivery/DeliveryDashboard';
import OrderDelivered from './Delivery/OrderDelivered';
import Contact from './components/Contact';
import SubOrderHistory from './SubAdmin/SubOrderHistory';
import ExchangeOrder from './components/ExchangeOrder';
import ExcDeliveryHistory from './Admin/ExcOrdersDelivered';
import ManagePres from './Admin/ManagePres';
import AccountDelete from './components/AccountDelete';
import AdminSocketListener from './Admin/AdminSocketListener';
import ManageCoupons from './Admin/ManageCoupons';
import Overview from './Admin/Overview';


const App = () => {
  const collapsed = false;
  const userData = JSON.parse(localStorage.getItem('userData'));
  const isAdmin = localStorage.getItem(('isAdmin'));
  const isSubAdmin = localStorage.getItem(('isStaff'));
  const isUser = localStorage.getItem(('isUser'));
  const isDeliveryAgent = localStorage.getItem(('isDeliveryAgent'));
 const [notifTypes, setNotifTypes] = useState({});

  const handleNewNotification = (title) => {
    setNotifTypes((prev) => ({ ...prev, [title]: true }));
  };

  const clearNotif = (title) => {
    setNotifTypes((prev) => ({ ...prev, [title]: false }));
  };

  return (
    <>
      <BrowserRouter>
        <ScrollTop />

        {!isAdmin && !isSubAdmin && !isUser && !isDeliveryAgent && (
          <>
            <Routes>
              <Route exact path='/' element={<Home />} />
              <Route exact path='/login' element={<Login />} />
              <Route exact path='/delivery-agent' element={<DeliveryLogin />} />
              <Route exact path='/medicine-details/:id' element={<ProductDetails isUser={isUser} />} />
              <Route exact path='/shop' element={<Shop />} />
              <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route exact path='/contact' element={<Contact />} />
              <Route exact path='/delete-account' element={<AccountDelete />} />
              <Route exact path='*' element={<PageNotFound />} />
            </Routes>
          </>
        )
        }

        {isAdmin && (
          <>
            <Sidebar notifTypes={notifTypes} clearNotif={clearNotif} userData={userData[0]} />
            <div className={`dashboard-sidebar-right ${collapsed ? "collapsed" : ""}`}>

<AdminSocketListener onNewNotification={handleNewNotification} />

                <Routes>
                  <Route exact path='/' element={<AdminDashboard />} />
                  <Route exact path='/dashboard' element={<AdminDashboard />} />
                  <Route exact path='/overview' element={<Overview />} />
                  <Route exact path='/add-product' element={<AddProduct />} />
                  <Route exact path='/product-details/:id' element={<ProDetails isAdmin={isAdmin} />} />
                  <Route exact path='/add-branch' element={<AddStaff />} />
                  <Route exact path='/add-delivery-agent' element={<AddDeliveryAgent userData={userData[0]} />} />
                  <Route exact path='/delivery-history' element={<DeliveryHistory userData={userData[0]} />} />
                  <Route exact path='/exchange-history' element={<ExcDeliveryHistory userData={userData[0]} />} />
                  <Route exact path='/profile' element={<Profile userData={userData[0]} isAdmin={isAdmin} />} />
                  <Route exact path='/manage-coupons' element={<ManageCoupons />} />
                  <Route exact path='/manage-orders' element={<ManageOrders />} />
                  <Route exact path='/manage-prescription' element={<ManagePres />} />
                  <Route exact path='/view-users' element={<Users userData={userData[0]} />} />
                  <Route exact path='*' element={<PageNotFound />} />
                </Routes>
              </div>
            <MobileSidebar userData={userData[0]} />
            </>
        )
        }

        {isSubAdmin && (
          <>
            <Sidebar userData={userData[0]} />
            <div className={`dashboard-sidebar-right ${collapsed ? "collapsed" : ""}`}>
                <Routes>
                  <Route exact path='/' element={<StaffDashboard userData={userData[0]} />} />
                  <Route exact path='/branch-dashboard' element={<StaffDashboard userData={userData[0]} />} />
                  <Route exact path='/profile' element={<Profile userData={userData[0]} isSubAdmin={isSubAdmin} />} />
                  <Route exact path='/product-details/:id' element={<ProDetails />} />
                  <Route exact path='/my-medicine' element={<Store userData={userData[0]} />} />
                  <Route exact path='/my-orders' element={<SubOrderHistory userData={userData[0]} />} />
                  <Route exact path='*' element={<PageNotFound />} />
                </Routes>
            </div>
            <MobileSidebar userData={userData[0]} />
            </>
        )
        }


        {isDeliveryAgent && (
          <>
            <div className="main-content">
              <Routes>
                <Route exact path='/' element={<DeliveryDashboard userData={userData[0]} />} />
                <Route exact path='/delivery-dashboard' element={<DeliveryDashboard userData={userData[0]} />} />
                <Route exact path='/profile' element={<Profile userData={userData[0]} isDeliveryAgent={isDeliveryAgent} />} />
                <Route exact path='/order-delivered' element={<OrderDelivered userData={userData[0]} />} />
                <Route exact path='*' element={<PageNotFound />} />
              </Routes>
            </div>
            <BottomBar isDeliveryAgent={isDeliveryAgent} />
          </>
        )}


        {isUser && (
          <>            <div className="main-content">
            <Routes>
              <Route exact path='/' element={<Home isUser={isUser} userData={userData[0]} />} />
              <Route exact path='/profile' element={<Profile userData={userData[0]} isUser={isUser} />} />
              <Route exact path='/shop' element={<Shop isUser={isUser} userData={userData[0]} />} />
              <Route exact path='/privacy-policy' element={<PrivacyPolicy isUser={isUser} userData={userData[0]} />} />
              <Route exact path='/contact' element={<Contact isUser={isUser} userData={userData[0]} />} />
              <Route exact path='/medicine-details/:id' element={<ProductDetails isUser={isUser} userData={userData[0]} />} />
              <Route exact path='/order-history' element={<OrderHistory isUser={isUser} userData={userData[0]} />} />
              <Route exact path='/exchange-order' element={<ExchangeOrder userData={userData[0]} />} />
              <Route exact path='/checkout' element={<Checkout isUser={isUser} userData={userData[0]} />} />
              <Route exact path='*' element={<PageNotFound />} />
            </Routes>
            {/* <Copyright /> */}
          </div>
            <BottomBar isUser={isUser} />
          </>
        )
        }


      </BrowserRouter>
    </>
  )
}

export default App
